<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png" />
  <HelloWorld msg="Welcome to Your Vue.js App" /> -->
  <!-- title INTERNAL CONTROL INSTITUTE OF KOREA -->
  <teleport to="#default">
    
  </teleport>
  <Home/>
</template>

<script setup>
// import HelloWorld from './components/HelloWorld.vue'
import Home from '@/layouts/home'
</script>


<!-- <style src="../src/assets/css/main.css"></style> -->
<!-- <style>
#app {
  font-family: Avenir, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style> -->
